var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunriseLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5C11.4477 2.5 11 2.94772 11 3.5V4.5C11 5.05228 11.4477 5.5 12 5.5C12.5523 5.5 13 5.05228 13 4.5V3.5C13 2.94772 12.5523 2.5 12 2.5Z",
    fill: "#12131A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05022 7.55086C6.65969 7.94138 6.02653 7.94138 5.636 7.55086L4.9289 6.84375C4.53837 6.45323 4.53837 5.82006 4.9289 5.42954C5.31942 5.03901 5.95259 5.03901 6.34311 5.42954L7.05022 6.13664C7.44074 6.52717 7.44074 7.16033 7.05022 7.55086Z",
    fill: "#12131A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0714 5.42976C18.6808 5.03924 18.0477 5.03924 17.6572 5.42976L16.95 6.13687C16.5595 6.52739 16.5595 7.16056 16.95 7.55108C17.3406 7.94161 17.9737 7.94161 18.3643 7.55108L19.0714 6.84398C19.4619 6.45345 19.4619 5.82029 19.0714 5.42976Z",
    fill: "#12131A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.5C9 10.8431 10.3431 9.5 12 9.5C13.6569 9.5 15 10.8431 15 12.5C15 13.0523 15.4477 13.5 16 13.5C16.5523 13.5 17 13.0523 17 12.5C17 9.73858 14.7614 7.5 12 7.5C9.23858 7.5 7 9.73858 7 12.5C7 13.0523 7.44772 13.5 8 13.5C8.55228 13.5 9 13.0523 9 12.5Z",
    fill: "#12131A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 11.5C21.5523 11.5 22 11.9477 22 12.5C22 13.0523 21.5523 13.5 21 13.5H20C19.4477 13.5 19 13.0523 19 12.5C19 11.9477 19.4477 11.5 20 11.5H21Z",
    fill: "#12131A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12.5C5 11.9477 4.55228 11.5 4 11.5H3C2.44772 11.5 2 11.9477 2 12.5C2 13.0523 2.44772 13.5 3 13.5H4C4.55228 13.5 5 13.0523 5 12.5Z",
    fill: "#12131A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.5C20 15.9477 19.5523 15.5 19 15.5H5C4.44772 15.5 4 15.9477 4 16.5C4 17.0523 4.44772 17.5 5 17.5L19 17.5C19.5523 17.5 20 17.0523 20 16.5Z",
    fill: "#12131A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20.5C16 19.9477 15.5523 19.5 15 19.5L9 19.5C8.44772 19.5 8 19.9477 8 20.5C8 21.0523 8.44772 21.5 9 21.5H15C15.5523 21.5 16 21.0523 16 20.5Z",
    fill: "#12131A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunriseLine);
export default __webpack_public_path__ + "static/media/sunrise-line.3c4b58dbcb313b5647f9a4f8d128938c.svg";
export { ForwardRef as ReactComponent };